import React from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepperItems from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';
import EArchiveGroupsListWrapper from '../EArchiveGroupsListWrapper/EArchiveGroupsListWrapper';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import EArchiveArchivedPatientsList from '../EArchiveArchivedPatientsList/EArchiveArchivedPatientsList';
import EArchiveRegisteredPatientsList from '../EArchiveRegisteredPatientsList/EArchiveRegisteredPatientsList';
import EArchivePatientsListWrapper from '../EArchivePatientsListWrapper/EArchivePatientsListWrapper';
import useCapitation from '../../../Workplace/Hooks/useCapitation';
import { useAppContext } from '../../../../Services/AppContext';

const EArchiveWrapper = () => {
	const { stopSelectingUsers } = useSelectUsersContext();
	const { workplaceId } = useAppContext();
	const { isCapitationAllowed } = useCapitation(workplaceId);

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.eArchive.all',
			key: 'all',
			component: () => <EArchivePatientsListWrapper />,
		},
	];

	if (isCapitationAllowed) {
		steps.push({
			name: 'component.eArchive.registered',
			key: 'registered',
			component: () => <EArchiveRegisteredPatientsList />,
		});
	}

	steps.push(
		{
			name: 'component.eArchive.groups.title',
			key: 'groups',
			component: () => <EArchiveGroupsListWrapper />,
		},
		{
			name: 'component.eArchive.archive',
			key: 'archive',
			component: () => <EArchiveArchivedPatientsList />,
		},
	);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath={'all'}
			canSkip
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={value => {
						stopSelectingUsers();
						onChange(value);
					}}
				/>
			)}
		/>
	);
};

export default EArchiveWrapper;
